import httpClient from "Api/httpClient";

const END_POINT = "/entity_addresses";

const getEntityAddresses = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getEntityAddress = (entity_addresses_id) => {
    if (!entity_addresses_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + entity_addresses_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printEntityAddress = (entity_addresses_id) => {
    if (!entity_addresses_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?entity_addresses_id=" + entity_addresses_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createEntityAddresses = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateEntityAddresses = (payload, entity_addresses_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + entity_addresses_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteEntityAddresses = (entity_addresses_id, new_prime_entity_addresses_id) => {
    new_prime_entity_addresses_id = new_prime_entity_addresses_id ? "/" + new_prime_entity_addresses_id : "";
    const DELETE_END_POINT = END_POINT + "/" + entity_addresses_id + new_prime_entity_addresses_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getEntityAddresses, getEntityAddress, printEntityAddress, createEntityAddresses, updateEntityAddresses, deleteEntityAddresses };
